var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgDoubleChevronRight = function SvgSvgDoubleChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.889 0c-.614 0-1.111.497-1.111 1.111V14.89a1.111 1.111 0 1 0 2.222 0V1.11C20 .497 19.503 0 18.889 0M1.482 16c-.38 0-.759-.15-1.048-.447a1.553 1.553 0 0 1 0-2.155l4.897-5.036L.62 3.344A1.556 1.556 0 0 1 .657 1.19a1.455 1.455 0 0 1 2.094.037l5.722 6.095a1.555 1.555 0 0 1-.018 2.137L2.53 15.553a1.46 1.46 0 0 1-1.047.446m7.408 0c-.38 0-.758-.15-1.047-.447a1.553 1.553 0 0 1 0-2.155l4.896-5.036-4.711-5.018a1.556 1.556 0 0 1 .037-2.155 1.455 1.455 0 0 1 2.095.037l5.721 6.095a1.555 1.555 0 0 1-.018 2.137l-5.926 6.095a1.46 1.46 0 0 1-1.047.446"
  })));
};
export default SvgSvgDoubleChevronRight;